import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { Field, Combobox } from "../Order/Field/Field";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import { showToast } from "../../../utils/Helper";

export const TradingDesk = ({ open, onToggle, data, selected, services, orderId }) => {
  const [tradingSelected, setTradingSelected] = useState(selected);
  const [loading, setLoading] = useState(true);
  const onChange = (recive) => {
    setTradingSelected(recive);
  };

  const updateTradingDesk = (orderId, TradingDeskId) => {
    let body = {
      orderid: orderId,
      tradingdeskid: TradingDeskId,
    };
    services.changeTradingDesks({ body }).then((r) => {
      if (r.response.result.Code == 200) {
        showToast("Trading Desk Changed");
        onToggle();
      } else {
        showToast(r.response.result.Description, true);
      }
    });
  };

  return (
    <Modal isOpen={open}>
      <ModalHeader>Change trading desk</ModalHeader>
      <ModalBody>
        <Field label={"Trading Desks"}>
          <Combobox
            value={tradingSelected}
            items={data.SdtTradingDesk.map((dt) => ({
              id: dt.Id,
              description: dt.Name,
            }))}
            onChange={(v) => onChange(v)}
            selected={selected}
            style={{ minWidth: "165px", marginRight: "30px" }}
          />
        </Field>
      </ModalBody>
      <ModalFooter>
        <LaddaButton
          className={"btn btn-buy"}
          //onChange={updateTradingDesk(order,tradingSelected)}
          onClick={() => updateTradingDesk(orderId, tradingSelected)}
          data-style={EXPAND_RIGHT}
          //loading={loading}
        >
          Change
        </LaddaButton>
        <Button color="light" onClick={onToggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
